module.exports = __webpack_public_path__ + "media/images/about-slider-img-08-b49e21c3c3f9751cf5d46f0b29b75438.jpg";